import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "../../app-state";
import { ArtefactApp } from "./ArtefactApp";
import "./artefact.css";
import "./editorial.css";
import "./archive.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <ArtefactApp />
      </AppProvider>
    </BrowserRouter>
  </StrictMode>,
);
